export const CURRENCIES_MAP = {
    "AFN": {
        "code": "AFN",
        "name": "Afghan afghani",
        "symbol": "؋"
    },
    "EUR": {
        "code": "EUR",
        "name": "Euro",
        "symbol": "€"
    },
    "ALL": {
        "code": "ALL",
        "name": "Albanian lek",
        "symbol": "L"
    },
    "DZD": {
        "code": "DZD",
        "name": "Algerian dinar",
        "symbol": "د.ج"
    },
    "USD": {
        "code": "USD",
        "name": "United States dollar",
        "symbol": "$"
    },
    "AOA": {
        "code": "AOA",
        "name": "Angolan kwanza",
        "symbol": "Kz"
    },
    "XCD": {
        "code": "XCD",
        "name": "East Caribbean dollar",
        "symbol": "$"
    },
    "ARS": {
        "code": "ARS",
        "name": "Argentine peso",
        "symbol": "$"
    },
    "AMD": {
        "code": "AMD",
        "name": "Armenian dram",
        "symbol": "֏"
    },
    "AWG": {
        "code": "AWG",
        "name": "Aruban florin",
        "symbol": "ƒ"
    },
    "AUD": {
        "code": "AUD",
        "name": "Australian dollar",
        "symbol": "$"
    },
    "AZN": {
        "code": "AZN",
        "name": "Azerbaijani manat",
        "symbol": "₼"
    },
    "BSD": {
        "code": "BSD",
        "name": "Bahamian dollar",
        "symbol": "$"
    },
    "BHD": {
        "code": "BHD",
        "name": "Bahraini dinar",
        "symbol": ".د.ب"
    },
    "BDT": {
        "code": "BDT",
        "name": "Bangladeshi taka",
        "symbol": "৳"
    },
    "BBD": {
        "code": "BBD",
        "name": "Barbadian dollar",
        "symbol": "$"
    },
    "BYN": {
        "code": "BYN",
        "name": "New Belarusian ruble",
        "symbol": "Br"
    },
    "BZD": {
        "code": "BZD",
        "name": "Belize dollar",
        "symbol": "$"
    },
    "XOF": {
        "code": "XOF",
        "name": "West African CFA franc",
        "symbol": "Fr"
    },
    "BMD": {
        "code": "BMD",
        "name": "Bermudian dollar",
        "symbol": "$"
    },
    "BTN": {
        "code": "BTN",
        "name": "Bhutanese ngultrum",
        "symbol": "Nu."
    },
    "BOB": {
        "code": "BOB",
        "name": "Bolivian boliviano",
        "symbol": "Bs."
    },
    "BAM": {
        "code": "BAM",
        "name": "Bosnia and Herzegovina convertible mark",
        "symbol": "KM"
    },
    "BWP": {
        "code": "BWP",
        "name": "Botswana pula",
        "symbol": "P"
    },
    "NOK": {
        "code": "NOK",
        "name": "Norwegian krone",
        "symbol": "kr"
    },
    "BRL": {
        "code": "BRL",
        "name": "Brazilian real",
        "symbol": "R$"
    },
    "GBP": {
        "code": "GBP",
        "name": "British pound",
        "symbol": "£"
    },
    "BND": {
        "code": "BND",
        "name": "Brunei dollar",
        "symbol": "$"
    },
    "BGN": {
        "code": "BGN",
        "name": "Bulgarian lev",
        "symbol": "лв"
    },
    "BIF": {
        "code": "BIF",
        "name": "Burundian franc",
        "symbol": "Fr"
    },
    "KHR": {
        "code": "KHR",
        "name": "Cambodian riel",
        "symbol": "៛"
    },
    "XAF": {
        "code": "XAF",
        "name": "Central African CFA franc",
        "symbol": "Fr"
    },
    "CAD": {
        "code": "CAD",
        "name": "Canadian dollar",
        "symbol": "$"
    },
    "CVE": {
        "code": "CVE",
        "name": "Cape Verdean escudo",
        "symbol": "Esc"
    },
    "KYD": {
        "code": "KYD",
        "name": "Cayman Islands dollar",
        "symbol": "$"
    },
    "CLP": {
        "code": "CLP",
        "name": "Chilean peso",
        "symbol": "$"
    },
    "CNY": {
        "code": "CNY",
        "name": "Chinese yuan",
        "symbol": "¥"
    },
    "COP": {
        "code": "COP",
        "name": "Colombian peso",
        "symbol": "$"
    },
    "KMF": {
        "code": "KMF",
        "name": "Comorian franc",
        "symbol": "Fr"
    },
    "CDF": {
        "code": "CDF",
        "name": "Congolese franc",
        "symbol": "Fr"
    },
    "NZD": {
        "code": "NZD",
        "name": "New Zealand dollar",
        "symbol": "$"
    },
    "CRC": {
        "code": "CRC",
        "name": "Costa Rican colón",
        "symbol": "₡"
    },
    "CUC": {
        "code": "CUC",
        "name": "Cuban convertible peso",
        "symbol": "$"
    },
    "ANG": {
        "code": "ANG",
        "name": "Netherlands Antillean guilder",
        "symbol": "ƒ"
    },
    "CZK": {
        "code": "CZK",
        "name": "Czech koruna",
        "symbol": "Kč"
    },
    "DKK": {
        "code": "DKK",
        "name": "Danish krone",
        "symbol": "kr"
    },
    "DJF": {
        "code": "DJF",
        "name": "Djiboutian franc",
        "symbol": "Fr"
    },
    "DOP": {
        "code": "DOP",
        "name": "Dominican peso",
        "symbol": "$"
    },
    "EGP": {
        "code": "EGP",
        "name": "Egyptian pound",
        "symbol": "E£"
    },
    "ERN": {
        "code": "ERN",
        "name": "Eritrean nakfa",
        "symbol": "Nfk"
    },
    "ETB": {
        "code": "ETB",
        "name": "Ethiopian birr",
        "symbol": "Br"
    },
    "FKP": {
        "code": "FKP",
        "name": "Falkland Islands Pound",
        "symbol": "£"
    },
    "FJD": {
        "code": "FJD",
        "name": "Fijian dollar",
        "symbol": "$"
    },
    "XPF": {
        "code": "XPF",
        "name": "CFP franc",
        "symbol": "Fr"
    },
    "GMD": {
        "code": "GMD",
        "name": "Gambian dalasi",
        "symbol": "D"
    },
    "GEL": {
        "code": "GEL",
        "name": "Georgian Lari",
        "symbol": "ლ"
    },
    "GHS": {
        "code": "GHS",
        "name": "Ghanaian cedi",
        "symbol": "₵"
    },
    "GIP": {
        "code": "GIP",
        "name": "Gibraltar pound",
        "symbol": "£"
    },
    "GTQ": {
        "code": "GTQ",
        "name": "Guatemalan quetzal",
        "symbol": "Q"
    },
    "GNF": {
        "code": "GNF",
        "name": "Guinean franc",
        "symbol": "Fr"
    },
    "GYD": {
        "code": "GYD",
        "name": "Guyanese dollar",
        "symbol": "$"
    },
    "HTG": {
        "code": "HTG",
        "name": "Haitian gourde",
        "symbol": "G"
    },
    "HNL": {
        "code": "HNL",
        "name": "Honduran lempira",
        "symbol": "L"
    },
    "HUF": {
        "code": "HUF",
        "name": "Hungarian forint",
        "symbol": "Ft"
    },
    "HKD": {
        "code": "HKD",
        "name": "Hong Kong dollar",
        "symbol": "$"
    },
    "ISK": {
        "code": "ISK",
        "name": "Icelandic króna",
        "symbol": "kr"
    },
    "INR": {
        "code": "INR",
        "name": "Indian rupee",
        "symbol": "₹"
    },
    "IDR": {
        "code": "IDR",
        "name": "Indonesian rupiah",
        "symbol": "Rp"
    },
    "IRR": {
        "code": "IRR",
        "name": "Iranian rial",
        "symbol": "﷼"
    },
    "IQD": {
        "code": "IQD",
        "name": "Iraqi dinar",
        "symbol": "ع.د"
    },
    "ILS": {
        "code": "ILS",
        "name": "Israeli new shekel",
        "symbol": "₪"
    },
    "JMD": {
        "code": "JMD",
        "name": "Jamaican dollar",
        "symbol": "$"
    },
    "JPY": {
        "code": "JPY",
        "name": "Japanese yen",
        "symbol": "¥"
    },
    "JOD": {
        "code": "JOD",
        "name": "Jordanian dinar",
        "symbol": "د.ا"
    },
    "KZT": {
        "code": "KZT",
        "name": "Kazakhstani tenge",
        "symbol": "₸"
    },
    "KES": {
        "code": "KES",
        "name": "Kenyan shilling",
        "symbol": "Sh"
    },
    "KWD": {
        "code": "KWD",
        "name": "Kuwaiti dinar",
        "symbol": "د.ك"
    },
    "KGS": {
        "code": "KGS",
        "name": "Kyrgyzstani som",
        "symbol": "с"
    },
    "LAK": {
        "code": "LAK",
        "name": "Lao kip",
        "symbol": "₭"
    },
    "LBP": {
        "code": "LBP",
        "name": "Lebanese pound",
        "symbol": "ل.ل"
    },
    "LSL": {
        "code": "LSL",
        "name": "Lesotho loti",
        "symbol": "L"
    },
    "LRD": {
        "code": "LRD",
        "name": "Liberian dollar",
        "symbol": "$"
    },
    "LYD": {
        "code": "LYD",
        "name": "Libyan dinar",
        "symbol": "ل.د"
    },
    "CHF": {
        "code": "CHF",
        "name": "Swiss franc",
        "symbol": "Fr"
    },
    "MOP": {
        "code": "MOP",
        "name": "Macanese pataca",
        "symbol": "P"
    },
    "MKD": {
        "code": "MKD",
        "name": "Macedonian denar",
        "symbol": "ден"
    },
    "MGA": {
        "code": "MGA",
        "name": "Malagasy ariary",
        "symbol": "Ar"
    },
    "MWK": {
        "code": "MWK",
        "name": "Malawian kwacha",
        "symbol": "MK"
    },
    "MYR": {
        "code": "MYR",
        "name": "Malaysian ringgit",
        "symbol": "RM"
    },
    "MVR": {
        "code": "MVR",
        "name": "Maldivian rufiyaa",
        "symbol": ".ރ"
    },
    "MRO": {
        "code": "MRO",
        "name": "Mauritanian ouguiya",
        "symbol": "UM"
    },
    "MUR": {
        "code": "MUR",
        "name": "Mauritian rupee",
        "symbol": "₨"
    },
    "MXN": {
        "code": "MXN",
        "name": "Mexican peso",
        "symbol": "$"
    },
    "MDL": {
        "code": "MDL",
        "name": "Moldovan leu",
        "symbol": "L"
    },
    "MNT": {
        "code": "MNT",
        "name": "Mongolian tögrög",
        "symbol": "₮"
    },
    "MAD": {
        "code": "MAD",
        "name": "Moroccan dirham",
        "symbol": "د.م."
    },
    "MZN": {
        "code": "MZN",
        "name": "Mozambican metical",
        "symbol": "MT"
    },
    "MMK": {
        "code": "MMK",
        "name": "Burmese kyat",
        "symbol": "Ks"
    },
    "NAD": {
        "code": "NAD",
        "name": "Namibian dollar",
        "symbol": "$"
    },
    "NPR": {
        "code": "NPR",
        "name": "Nepalese rupee",
        "symbol": "₨"
    },
    "NIO": {
        "code": "NIO",
        "name": "Nicaraguan córdoba",
        "symbol": "C$"
    },
    "NGN": {
        "code": "NGN",
        "name": "Nigerian naira",
        "symbol": "₦"
    },
    "KPW": {
        "code": "KPW",
        "name": "North Korean won",
        "symbol": "₩"
    },
    "OMR": {
        "code": "OMR",
        "name": "Omani rial",
        "symbol": "ر.ع."
    },
    "PKR": {
        "code": "PKR",
        "name": "Pakistani rupee",
        "symbol": "₨"
    },
    "PAB": {
        "code": "PAB",
        "name": "Panamanian balboa",
        "symbol": "B/."
    },
    "PGK": {
        "code": "PGK",
        "name": "Papua New Guinean kina",
        "symbol": "K"
    },
    "PYG": {
        "code": "PYG",
        "name": "Paraguayan guaraní",
        "symbol": "₲"
    },
    "PEN": {
        "code": "PEN",
        "name": "Peruvian sol",
        "symbol": "S/."
    },
    "PHP": {
        "code": "PHP",
        "name": "Philippine peso",
        "symbol": "₱"
    },
    "PLN": {
        "code": "PLN",
        "name": "Polish złoty",
        "symbol": "zł"
    },
    "QAR": {
        "code": "QAR",
        "name": "Qatari riyal",
        "symbol": "ر.ق"
    },
    "RON": {
        "code": "RON",
        "name": "Romanian leu",
        "symbol": "lei"
    },
    "RUB": {
        "code": "RUB",
        "name": "Russian ruble",
        "symbol": "₽"
    },
    "RWF": {
        "code": "RWF",
        "name": "Rwandan franc",
        "symbol": "Fr"
    },
    "SHP": {
        "code": "SHP",
        "name": "Saint Helena pound",
        "symbol": "£"
    },
    "WST": {
        "code": "WST",
        "name": "Samoan tālā",
        "symbol": "T"
    },
    "STD": {
        "code": "STD",
        "name": "São Tomé and Príncipe dobra",
        "symbol": "Db"
    },
    "SAR": {
        "code": "SAR",
        "name": "Saudi riyal",
        "symbol": "ر.س"
    },
    "RSD": {
        "code": "RSD",
        "name": "Serbian dinar",
        "symbol": "дин."
    },
    "SCR": {
        "code": "SCR",
        "name": "Seychellois rupee",
        "symbol": "₨"
    },
    "SLL": {
        "code": "SLL",
        "name": "Sierra Leonean leone",
        "symbol": "Le"
    },
    "SGD": {
        "code": "SGD",
        "name": "Singapore dollar",
        "symbol": "$"
    },
    "SBD": {
        "code": "SBD",
        "name": "Solomon Islands dollar",
        "symbol": "$"
    },
    "SOS": {
        "code": "SOS",
        "name": "Somali shilling",
        "symbol": "Sh"
    },
    "ZAR": {
        "code": "ZAR",
        "name": "South African rand",
        "symbol": "R"
    },
    "KRW": {
        "code": "KRW",
        "name": "South Korean won",
        "symbol": "₩"
    },
    "LKR": {
        "code": "LKR",
        "name": "Sri Lankan rupee",
        "symbol": "Rs"
    },
    "SDG": {
        "code": "SDG",
        "name": "Sudanese pound",
        "symbol": "ج.س."
    },
    "SSP": {
        "code": "SSP",
        "name": "South Sudanese pound",
        "symbol": "£"
    },
    "SRD": {
        "code": "SRD",
        "name": "Surinamese dollar",
        "symbol": "$"
    },
    "SZL": {
        "code": "SZL",
        "name": "Swazi lilangeni",
        "symbol": "L"
    },
    "SEK": {
        "code": "SEK",
        "name": "Swedish krona",
        "symbol": "kr"
    },
    "SYP": {
        "code": "SYP",
        "name": "Syrian pound",
        "symbol": "£"
    },
    "TWD": {
        "code": "TWD",
        "name": "New Taiwan dollar",
        "symbol": "$"
    },
    "TJS": {
        "code": "TJS",
        "name": "Tajikistani somoni",
        "symbol": "ЅМ"
    },
    "TZS": {
        "code": "TZS",
        "name": "Tanzanian shilling",
        "symbol": "Sh"
    },
    "THB": {
        "code": "THB",
        "name": "Thai baht",
        "symbol": "฿"
    },
    "TOP": {
        "code": "TOP",
        "name": "Tongan paʻanga",
        "symbol": "T$"
    },
    "TTD": {
        "code": "TTD",
        "name": "Trinidad and Tobago dollar",
        "symbol": "$"
    },
    "TND": {
        "code": "TND",
        "name": "Tunisian dinar",
        "symbol": "د.ت"
    },
    "TRY": {
        "code": "TRY",
        "name": "Turkish lira",
        "symbol": "₺"
    },
    "TMT": {
        "code": "TMT",
        "name": "Turkmenistan manat",
        "symbol": "m"
    },
    "UGX": {
        "code": "UGX",
        "name": "Ugandan shilling",
        "symbol": "Sh"
    },
    "UAH": {
        "code": "UAH",
        "name": "Ukrainian hryvnia",
        "symbol": "₴"
    },
    "AED": {
        "code": "AED",
        "name": "United Arab Emirates dirham",
        "symbol": "د.إ"
    },
    "UYU": {
        "code": "UYU",
        "name": "Uruguayan peso",
        "symbol": "$"
    },
    "UZS": {
        "code": "UZS",
        "name": "Uzbekistani so\\\\'m",
        "symbol": "so\\\\'m"
    },
    "VUV": {
        "code": "VUV",
        "name": "Vanuatu vatu",
        "symbol": "Vt"
    },
    "VEF": {
        "code": "VEF",
        "name": "Venezuelan bolívar",
        "symbol": "Bs S"
    },
    "VND": {
        "code": "VND",
        "name": "Vietnamese đồng",
        "symbol": "₫"
    },
    "YER": {
        "code": "YER",
        "name": "Yemeni rial",
        "symbol": "﷼"
    },
    "ZMW": {
        "code": "ZMW",
        "name": "Zambian kwacha",
        "symbol": "K"
    }
}

export const getCurrency = (code) => {
  if (!code) {
    return {code: 'EUR', name: 'Euro', symbol: '€'}
  }
  return CURRENCIES_MAP[code.toUpperCase()] || {code: 'EUR', name: 'Euro', symbol: '€'}
}